import { render } from "./xiangmu_data.vue?vue&type=template&id=22811eb8&scoped=true"
import script from "./xiangmu_data.vue?vue&type=script&lang=js"
export * from "./xiangmu_data.vue?vue&type=script&lang=js"

import "./xiangmu_data.vue?vue&type=style&index=0&id=22811eb8&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22811eb8"]])

export default __exports__